// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"624f8e29","703":"3bf94c98","787":"ed0eff6b"}[chunkId] + ".chunk.js";
};